import React from 'react';

export function PriceColumnFormatter(cellContent) {

  return (
    <div className="text-dark-75 font-weight-bolder d-block font-size-h5 text-nowrap">
      {cellContent ? (cellContent).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0'}
    </div>
  );
}
